import { render } from "./UsernameModal.vue?vue&type=template&id=678970fc&scoped=true"
import script from "./UsernameModal.vue?vue&type=script&lang=js"
export * from "./UsernameModal.vue?vue&type=script&lang=js"

import "./UsernameModal.vue?vue&type=style&index=0&id=678970fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678970fc"]])

export default __exports__